import React from 'react'
import Pt from 'prop-types'
import cx from 'classnames'

import Currency from 'internal-components/src/components/Currency'
import UpdatingAgo from 'internal-components/src/components/Time/UpdatingAgo'
import { PaymentRecord } from 'internal-components/src/records'

import './Details.css'

export default function PaymentDetails({ payment }) {
  return (
    <div className={cx('payment-details', { failed: !payment.success })}>
      {payment.reference} &mdash; <Currency amount={payment.amount} />
      <br />
      <UpdatingAgo Component="small" moment={payment.paymentDate} />
    </div>
  )
}

PaymentDetails.propTypes = {
  payment: Pt.instanceOf(PaymentRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Payment/Details.jsx